const careerSl = {
  breadcrumbs: { home: 'මුල් පිටුව', career: 'කාර්ය මාර්ගය' },
  hero: {
    title: 'ඔබගේ සිහිනයේ කාර්ය මාර්ගය ආරම්භ කරන්න',
    subtitle: 'Grameen Bazar සමඟ එක්වී බංග්ලාදේශයේ ග්‍රාමීය වෙළඳාම ඩිජිටල් යුගයට ගෙන එන්න'
  },
  companyStats: [
    { value: '500+', label: 'සේවකයින්' },
    { value: '10+', label: 'කාර්යාල' },
    { value: '98%', label: 'සේවක සතුටුදායීභාවය' },
    { value: '100+', label: 'පුහුණු වැඩසටහන්' }
  ],
  jobsSection: { title: 'ඇැඳරුණු තනතුරු', subtitle: 'අප සමඟ වැඩ කර ඔබගේ කාර්ය මාර්ගය වර්ධනය කරන්න' },
  labels: { featured: 'විශේෂ', postedSuffix: 'ප්‍රකාශිත', salary: 'ශම්භල', deadline: 'අයදුම් අවසන් දිනය' },
  buttons: { viewDetails: 'විස්තර බලන්න', apply: 'අයදුම් කරන්න', cancel: 'අවලංගු', submit: 'අයදුම්පත යවන්න', contact: 'අපව අමතන්න' },
  cta: { title: 'ඔබට ගැලපෙන තනතුරක් තිබේද?', subtitle: 'අපව අමතන්න. නව අවස්ථා පිළිබඳව අපි දැනුම් දෙමු.', contact: 'අපව අමතන්න' },
  form: {
    titleSuffix: ' - අයදුම් පත්‍රය',
    name: 'නාමය',
    email: 'ඊමේල්',
    phone: 'දුරකථන',
    education: 'අධ්‍යාපන සුදුසුකම්',
    experience: 'ක්‍රියාත්මක අත්දැකීම්',
    uploadResume: 'රෙසිමේ උඩුගත කරන්න (PDF, DOC, DOCX)'
  },
  snackbar: { success: 'ඔබගේ අයදුම්පත යවා ඇත. අපි ඉක්මනින් සම්බන්ධ වන්නෙමු.' }
};

export default careerSl;


